module.exports = __webpack_public_path__ + "img/ic_liveticker_tor.d6fe9c7f.svg";